module.exports = "<div class=\"loading-wrap\" *ngIf=\"loading\">\n  <div class=\"loading-box\"></div>\n</div>\n"